import React, { Component } from 'react';
import { View, Dimensions } from 'react-native';
import { styles } from '../../../css/container';
import { dialog } from '../../../css/dialog';
import { modal } from '../../../css/modal';
import Button from '../core/Button';
import Text from '../core/Text';
import GlobalConstants from '../GlobalConstants';
import GlobalVariables from '../GlobalVariables';
import { BaseDlgProps } from '../props/BaseDlgProps';
import t from '../../../translation';

class CYESNO extends Component<BaseDlgProps> {
    start: number;
    index: number;
    title: string;
    text: string;
    yes: boolean;
    time: number = 15;
    constructor(props: BaseDlgProps) {
        super(props);
        setInterval(() => {
            if (this.props.m_pwin.messageYESNOVisible[this.index]) {
                if (this.props.m_pwin.IsGameOnline()) {
                    this.time = this.time - 1;
                }
                this.setState({});
                if (this.time <= 0) {
                    this.props.m_pwin.messageYESNOVisible[this.index] = false;
                    if (this.props.m_pwin.m_main.getIsTest()) {
                        this.yes = true;
                    } else {
                        this.yes = false;
                    }
                    this.start = 0;
                }
            }
        }, 1000);
    }

    SetTitle(text: string, title = 'Favorite Games ' + GlobalConstants.GAME_VERSION) {
        this.text = t.t(text);
        this.title = t.t(title);
    }

    performTimeConsumingTask = async () => {
        return new Promise((resolve) =>
            setTimeout(() => {
                resolve(GlobalConstants.IDOK);
            }, 100)
        );
    };

    componentDidMount() {
        this.props.onRef(this);
    }
    OnOk() {
        this.yes = true;
        this.start = 0;
    }
    OnCancel() {
        this.yes = false;
        this.start = 0;
    }

    initTimer() {
        this.time = this.props.m_pwin.m_main.GetCloseDialogTimer();
        this.setState({});
    }

    async DoModal() {
        this.index = this.props.m_pwin.messageyesnoIndex;
        this.props.m_pwin.messageyesnoIndex = this.props.m_pwin.messageyesnoIndex + 1;
        this.props.m_pwin.messageYESNOVisible[this.index] = true;
        this.props.m_pwin.setState({});
        this.start = 1;
        this.initTimer();
        while (this.start === 1 && this.time > 0 && this.props.m_pwin.messageYESNOVisible[this.index] && this.props.m_pwin.props.isAppActive) {
            await this.performTimeConsumingTask();
        }
        this.props.m_pwin.messageYESNOVisible[this.index] = false;
        this.props.m_pwin.setState({});
        if (this.yes === true || this.props.m_pwin.m_main.getIsTest()) {
            return GlobalConstants.IDOK;
        } else {
            return GlobalConstants.IDNO;
        }
    }

    render() {
        if (this.props.m_pwin.messageYESNOVisible[this.index] === true) {
            return (
                <View style={[styles.modal, { width: Dimensions.get('window').width, height: Dimensions.get('window').height }]}>
                    <View
                        style={[
                            dialog.dialogView,
                            {
                                top:
                                    GlobalVariables.WindowHeight * 0.3 -
                                    Math.min(this.index * 80, GlobalVariables.WindowHeight * 0.3 - 20 * GlobalVariables.scale),
                                left: GlobalVariables.positionLeft + 20 * GlobalVariables.scale,
                                width: 750 * GlobalVariables.scale,
                            },
                        ]}
                    >
                        <View style={styles.doalogTitle}>
                            <Text textSize={GlobalConstants.LARGE_FONT_SIZE}>{this.title}</Text>
                        </View>
                        <View style={[styles.row, styles.padding1]}>
                            <Text textSize={GlobalConstants.LARGE_FONT_SIZE}>{this.text}</Text>
                        </View>
                        <View style={styles.row}>
                            <Button
                                textSize={GlobalConstants.SUPER_EXTRA_LARGE_FONT_SIZE}
                                containerStyle={modal.buttonStyle3PerRow}
                                onPress={this.OnOk.bind(this)}
                                text="Yes"
                            />
                            <Button
                                textSize={GlobalConstants.SUPER_EXTRA_LARGE_FONT_SIZE}
                                containerStyle={modal.buttonStyle3PerRow}
                                onPress={this.OnCancel.bind(this)}
                                text="No"
                            />
                        </View>
                        {this.props.m_pwin.IsGameOnline() ? (
                            <View style={styles.row}>
                                <Text textSize={GlobalConstants.LARGE_FONT_SIZE}>{this.time.toString()}</Text>
                            </View>
                        ) : null}
                    </View>
                </View>
            );
        } else {
            return null;
        }
    }
}

export default CYESNO;
